export default __webpack_public_path__ + "static/media/ibm-cloud.a3b3ef1a.svg";